import React from 'react';
import PropTypes from 'prop-types';
import { isAbsent } from 'helpers/verify';
import { CitcatLinks } from 'components/CmsPage/modules/CitcatLinks/CitcatLinks';
import { FreeTrialSignupV2 } from 'components/CmsPage/modules/Experimental/FreeTrialSignup/FreeTrialSignupV2';
import { FreeTrialSignupV3 } from 'components/CmsPage/modules/Experimental/FreeTrialSignup/FreeTrialSignupV3';
import { HowItWorksV1 } from 'components/CmsPage/modules/Experimental/HowItWorks/HowItWorksV1';
import { LocationSelector } from 'components/CmsPage/modules/LocationSelector/LocationSelector';
import { PressTestimonials } from 'components/PressTestimonials/PressTestimonials';
import { SearchBoxContainer } from 'features/Search/SearchBox/SearchBoxContainer';
import { WhyClassPassV1 } from 'components/CmsPage/modules/Experimental/WhyClassPass/WhyClassPassV1';
import { SEARCHBOX_THEMES } from 'features/Search/SearchBox/SearchBox.constants';
var STATIC_MODULE_RENDERER_BY_NAME = {
  citcat_links_light: function citcat_links_light() {
    return React.createElement(CitcatLinks, {
      backgroundColor: "light"
    });
  },
  citcat_links_white: function citcat_links_white() {
    return React.createElement(CitcatLinks, {
      backgroundColor: "white"
    });
  },
  free_trial_signup_v2: function free_trial_signup_v2() {
    return React.createElement(FreeTrialSignupV2, null);
  },
  free_trial_signup_v3: function free_trial_signup_v3() {
    return React.createElement(FreeTrialSignupV3, null);
  },
  how_it_works_v1: function how_it_works_v1() {
    return React.createElement(HowItWorksV1, null);
  },
  location_selector: function location_selector() {
    return React.createElement(LocationSelector, null);
  },
  press_testimonials: function press_testimonials() {
    return React.createElement(PressTestimonials, null);
  },
  search_box_on_home_hero: function search_box_on_home_hero() {
    return React.createElement(SearchBoxContainer, {
      optimizelyEventTrackingName: "Search on Home (hero) click",
      theme: SEARCHBOX_THEMES.onDarkCentered
    });
  },
  why_classpass_v1: function why_classpass_v1() {
    return React.createElement(WhyClassPassV1, null);
  }
};
export var StaticModule = function StaticModule(_ref) {
  var moduleName = _ref.moduleName,
      _ref$moduleRendererBy = _ref.moduleRendererByName,
      moduleRendererByName = _ref$moduleRendererBy === void 0 ? STATIC_MODULE_RENDERER_BY_NAME : _ref$moduleRendererBy;
  var moduleRenderer = moduleRendererByName[moduleName];

  if (isAbsent(moduleRenderer)) {
    // eslint-disable-next-line no-console
    console.error("Module [".concat(moduleName, "] is not registered"));
    return null;
  }

  return moduleRenderer();
};
StaticModule.propTypes = {
  moduleName: PropTypes.string.isRequired
};